import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BooleanFilterComponent } from '../shared/components/boolean-filter/boolean-filter.component';
import { DateFilterComponent } from '../shared/components/date-filter/date-filter.component';
import { DateTimeRangeFilterComponent } from '../shared/components/dateTime-range-filter/dateTime-range-filter.component';
import { DetailsEmptyComponent } from '../shared/components/details-empty/details-empty.component';
import { EditViewButtonComponent } from '../shared/components/edit-view-button/edit-view-button.component';
import { InputFilterComponent } from '../shared/components/input-filter/input-filter.component';
import { InputOutputFilterComponent } from '../shared/components/input-output-filter/input-output-filter.component';
import { ListFilterComponent } from '../shared/components/list-filter/list-filter.component';
import { SearchSelectMultipleComponent } from '../shared/components/search-select-multiple/search-select-multiple.component';
import { StatusFilterComponent } from '../shared/components/status-filter/status-filter.component';
import { UserEditDialogComponent } from '../shared/components/user-edit-dialog/user-edit-dialog.component';
import { PrettifyXmlPipe } from '../shared/pipes/prettify-xml.pipe';
import { TruncatePipe } from '../shared/pipes/truncate.pipe';
import { SortByPipe} from '../shared/pipes/sortBy.pipe';
import { PluginFileComponent } from './../shared/components/plugin-file/plugin-file.component';
import { PluginSettingsComponent } from './../shared/components/plugin-settings/plugin-settings.component';
import { MappingRuleConfigurationComponent } from './customers/components/mapping-rule-configuration/mapping-rule-configuration.component';
import { MaterialModule } from './material.module';


@NgModule({
  declarations: [
    DetailsEmptyComponent,
    PluginSettingsComponent,
    PluginFileComponent,
    PrettifyXmlPipe,
    TruncatePipe,
    SortByPipe,
    SearchSelectMultipleComponent,
    DateFilterComponent,
    DateTimeRangeFilterComponent,
    InputOutputFilterComponent,
    StatusFilterComponent,
    InputFilterComponent,
    UserEditDialogComponent,
    BooleanFilterComponent,
    ListFilterComponent,
    MappingRuleConfigurationComponent,
    EditViewButtonComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    DetailsEmptyComponent,
    PluginSettingsComponent,
    PluginFileComponent,
    PrettifyXmlPipe,
    TruncatePipe,
    SortByPipe,
    SearchSelectMultipleComponent,
    DateFilterComponent,
    DateTimeRangeFilterComponent,
    InputOutputFilterComponent,
    StatusFilterComponent,
    InputFilterComponent,
    BooleanFilterComponent,
    ListFilterComponent,
    MappingRuleConfigurationComponent,
    EditViewButtonComponent
  ]
})
export class SharedModule { }
